export default function Theme2(colors, mode) {
	const { grey } = colors;
	
	const contrastText = '#fff';
	let primaryColors = [
		'#ecf0ff', // lighter - very soft background (secondary)
		'#dde3ff', // 100 - light neutral
		'#c2cbff', // 200 - light gray-blue
		'#9ca7ff', // light - medium gray
		'#7578ff', // 400 - slightly darker
		'#635bff', // main - deep indigo
		'#4e36f5', // dark - same with transparency
		'#432ad8', // 700 - almost black
		'#302689', // darker
		'#1e1650'  // 900
	]
	
	let secondaryColors = [
		'#fbfcfe', // lighter - soft UI tone
		'#f0f4f8', // 100 - very light background
		'#dde7ee', // 200 - neutral light
		'#555e68', // light
		'#9fa6ad', // 400 - medium gray
		'#32383e', // main - main text color
		'#202427', // dark
		'#32383e', // 700
		'#202427', // darker
		'#090a0b'  // 900
	]
	
	let errorColors = [
		'#FFEDEE', // lighter - soft error
		'#FF8880', // light - gentle red
		'#F04134', // main
		'#C9302C', // dark
		'#A52825'  // darker
	]
	
	let warningColors = [
		'#FFF8E1', // lighter
		'#FFE082', // light
		'#FFBF00', // main
		'#FFB300', // dark
		'#FFA000'  // darker
	]
	
	let infoColors = [
		'#E0F4F5', // lighter
		'#2E94FF', // light - blue highlight from provided palette
		'#00A2AE', // main
		'#009AA7', // dark
		'#008694'  // darker
	]
	
	let successColors = [
		'#E0F5EA', // lighter
		'#81C784', // light
		'#388E3C', // main
		'#2E7D32', // dark
		'#1B5E20'  // darker
	]
	
	let text = ['#020700', '#0C1217', '#616161']
	
	return {
		...colors,
		primary: {
			lighter: primaryColors[0],
			100: primaryColors[1],
			200: primaryColors[2],
			light: primaryColors[3],
			400: primaryColors[4],
			main: primaryColors[5],
			dark: primaryColors[6],
			700: primaryColors[7],
			darker: primaryColors[8],
			900: primaryColors[9],
			contrastText
		},
		secondary: {
			lighter: secondaryColors[0],
			100: secondaryColors[1],
			200: secondaryColors[2],
			light: secondaryColors[3],
			400: secondaryColors[4],
			main: secondaryColors[5],
			dark: secondaryColors[6],
			700: secondaryColors[7],
			darker: secondaryColors[8],
			900: secondaryColors[9],
			contrastText
		},
		error: {
			lighter: errorColors[0],
			light: errorColors[1],
			main: errorColors[2],
			dark: errorColors[3],
			darker: errorColors[4],
			contrastText
		},
		warning: {
			lighter: warningColors[0],
			light: warningColors[1],
			main: warningColors[2],
			dark: warningColors[3],
			darker: warningColors[4],
			contrastText
		},
		info: {
			lighter: infoColors[0],
			light: infoColors[1],
			main: infoColors[2],
			dark: infoColors[3],
			darker: infoColors[4],
			contrastText
		},
		success: {
			lighter: successColors[0],
			light: successColors[1],
			main: successColors[2],
			dark: successColors[3],
			darker: successColors[4],
			contrastText
		},
		background: {
			default: '#E6E6FA'
		},
		common: {
			black: '#000000',
			white: '#ffffff'
		},
		text: {
			primary: text[0],
			secondary: text[1],
			hint: text[2],
			contrastText
		},
		action: {
			disabled: grey[500]
		},
		divider: grey[400],
		gridColors: {
			borders: '#e0e0e0',
			headerBackground: 'transparent',
			headerFont: '#020700',
			headerSvg: '#616161'
		},
		buttonColors: {
			containedHoverBackground: secondaryColors[5],
			containedHoverColor: contrastText,
			containedColor: secondaryColors[5],
			containedBackground: '#FFFFFF'
		},
		pageTitle: {
			textColor: primaryColors[5],
			backgroundColor: 'transparent',
			dividerColor: 'rgb(230, 233, 239)'
		},
		drawerBackgroundColor: '#f9f9f9',
		drawerMenuBackgroundColor: '#000000',
		headerBackgroundColor: '#000000',
		headerBackgroundGradientColor: '#000000',
		inputPalette: {
			labelColor: '#3474a4',
			labelBackground: 'transparent',
			inputColor: text[0],
			inputBackground: 'transparent',
			disableUnderline: false,
			borderBottom: `inherit`
		},
		formBox: {
			titleColor: text[0],
			titleBackground: 'transparent',
			dividerColor: primaryColors[5]
		},
		linkStyles: {
			hoverColor: infoColors[4],
			color: '#2a5986'
		}
	}
}